import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadConfigData } from 'src/app/shared/store/actions/shared.actions';
import { SharedState } from 'src/app/shared/store/reducers';


@Injectable({
  providedIn: 'root'
})
export class SharedConfigService {

  configDetail: any = {};

  constructor(private store:Store<SharedState>) { }


  loadAppConfig() {
    const user = localStorage.getItem('currentUser');
    if(user){
     this.store.dispatch(loadConfigData())
    }
  }

  get configDetails() {
    return this.configDetail;
  }

}
